import React, { useMemo } from 'react';

const COLORS = [
  { bg: 'rgba(66, 195, 186, 0.08)', border: '#42C3BA', text: '#0d9488' },
  { bg: 'rgba(59, 130, 246, 0.08)', border: '#3b82f6', text: '#2563eb' },
  { bg: 'rgba(245, 158, 11, 0.08)', border: '#f59e0b', text: '#d97706' },
  { bg: 'rgba(239, 68, 68, 0.08)', border: '#ef4444', text: '#dc2626' },
  { bg: 'rgba(139, 92, 246, 0.08)', border: '#8b5cf6', text: '#7c3aed' },
  { bg: 'rgba(236, 72, 153, 0.08)', border: '#ec4899', text: '#db2777' },
  { bg: 'rgba(16, 185, 129, 0.08)', border: '#10b981', text: '#059669' },
  { bg: 'rgba(249, 115, 22, 0.08)', border: '#f97316', text: '#ea580c' },
  { bg: 'rgba(6, 182, 212, 0.08)', border: '#06b6d4', text: '#0891b2' },
  { bg: 'rgba(148, 163, 184, 0.08)', border: '#94a3b8', text: '#64748b' },
];

export default function EstadisticasEstadoChart({ stros, estados, activeEstado, onSelectEstado }) {
  // Map estado IDs to names
  const estadoMap = useMemo(() => {
    const map = {};
    if (estados && Array.isArray(estados)) {
      estados.forEach(e => {
        map[e.id] = e.nombre || e.estado || `Estado ${e.id}`;
      });
    }
    return map;
  }, [estados]);

  // Count stros per estado
  const estadoCounts = useMemo(() => {
    const counts = {};
    if (!stros) return [];

    stros.forEach(s => {
      if (s.estados && Array.isArray(s.estados)) {
        s.estados.forEach(estId => {
          counts[estId] = (counts[estId] || 0) + 1;
        });
      } else if (s.estadoNuevo !== undefined && s.estadoNuevo !== null) {
        counts[s.estadoNuevo] = (counts[s.estadoNuevo] || 0) + 1;
      }
    });

    return Object.entries(counts)
      .map(([id, count]) => {
        const numId = Number(id);
        return {
          id: numId,
          name: estadoMap[numId] || `Estado ${numId}`,
          count,
        };
      })
      .sort((a, b) => b.count - a.count);
  }, [stros, estadoMap]);

  if (!stros || stros.length === 0) {
    return (
      <div className="est-card">
        <div className="est-card-header">
          <span className="est-card-title">
            <i className="bi bi-tag-fill"></i>
            Distribución por Estado
          </span>
        </div>
        <div className="est-empty">
          <i className="bi bi-inbox"></i>
          <p>No hay datos de estados</p>
        </div>
      </div>
    );
  }

  return (
    <div className="est-card">
      <div className="est-card-header">
        <span className="est-card-title">
          <i className="bi bi-tag-fill"></i>
          Distribución por Estado
        </span>
        <span className="est-card-badge">
          {estadoCounts.length} estados activos
        </span>
      </div>

      <div className="est-chips-grid">
        {/* "Todos" chip */}
        <button
          className={`est-chip ${activeEstado === null ? 'active' : ''}`}
          onClick={() => onSelectEstado(null)}
          style={{
            '--chip-color': '#0f172a',
            '--chip-border': activeEstado === null ? '#42C3BA' : '#e2e8f0',
            '--chip-bg': activeEstado === null ? 'rgba(66, 195, 186, 0.08)' : 'white',
          }}
        >
          <span className="est-chip-label">Todos</span>
          <span className="est-chip-count">{stros.length}</span>
        </button>

        {estadoCounts.map((item, idx) => {
          const color = COLORS[idx % COLORS.length];
          const isActive = activeEstado === item.id;

          return (
            <button
              key={item.id}
              className={`est-chip ${isActive ? 'active' : ''}`}
              onClick={() => onSelectEstado(isActive ? null : item.id)}
              style={{
                '--chip-color': color.text,
                '--chip-border': isActive ? color.border : '#e2e8f0',
                '--chip-bg': isActive ? color.bg : 'white',
              }}
              title={item.name}
            >
              <span className="est-chip-label">{item.name}</span>
              <span className="est-chip-count">{item.count}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
